import { Box, Grid2 } from "@mui/material";
import styles from "../CustomWidgets.module.scss";
import UltrasoundWidget from "../widgets/ultrasound/UltrasoundWidget";
import BabySizeImageWidget from "../../../features/baby-size-image-widget/BabySizeImageWidget";

const BabySectionGrid = ({
  onViewAll,
  isBabyDelivered,
}: {
  onViewAll: () => void;
  isBabyDelivered: boolean;
}) => (
  <Box className={styles.desktopBabyWeekUltrasoundWidgetBackground}>
    <Grid2
      container
      spacing={{ md: 3, xs: 5 }}
      className={styles.gridContainer}
    >
      {!isBabyDelivered && (
        <Grid2 size={{ xs: 12, md: 6 }} className={styles.babyWeekWidget}>
          <BabySizeImageWidget handleViewAll={onViewAll} />
        </Grid2>
      )}
      <Grid2
        size={{ xs: 12, md: 6 }}
        sx={{
          ...(isBabyDelivered && {
            mx: { md: "auto" },
          }),
        }}
        className={styles.ultrasoundWidget}
      >
        <UltrasoundWidget />
      </Grid2>
    </Grid2>
  </Box>
);

export default BabySectionGrid;
